import CryptoJS from 'crypto-js';
import {BTTrackerBase} from './base';

export class RockerBoxTracker extends BTTrackerBase {
  constructor(args) {
    super(args);
    this.actions = ['identity', 'lead'];
  }

  configure({rockerBox = {}, ...restConfig}, ...restArgs) {
    super.configure({rockerBox, ...restConfig}, ...restArgs);
    this.tagId = rockerBox.tagId;

    if (!rockerBox.tagId) {
      this.disable();
      this.log('This tracker has been disabled by the configuration settings.');
    }
  }

  getName() {
    return 'RockerBoxTracker';
  }

  get requiresTrackingConsent() {
    return true;
  }

  get restrictsEventsWithoutConsent() {
    return true;
  }

  init(...params) {
    if (!this.canInitialize()) {
      return false;
    }

    this.loadTag();

    window.RB.disablePushState = true;

    if (window.RB.initialize) {
      window.RB.initialize(this.tagId);
    }

    this.log('RockerBox script reference initialized');
    return super.init(...params);
  }

  loadTag() {
    // eslint-disable-next-line
    (function(d,RB) {if (!window.RB) { window.RB=RB;RB.queue=RB.queue||[];RB.track=RB.track||function(){RB.queue.push(Array.prototype.slice.call(arguments))};RB.initialize=function(s){RB.source=s};var a = d.createElement("script");  a.type="text/javascript"; a.async=!0; a.src="https://rbs3ipv4.biotrust.com/assets/wxyz.rb.js"; var f=d.getElementsByTagName("script")[0]; f.parentNode.insertBefore(a,f);} } )(document,window.RB || {});
  }

  action(type, action, category, data) {
    if (!super.action(type, action, category, data)) {
      return false;
    }

    if (data.success && this.actions.includes(type)) {
      /* eslint-disable camelcase */
      const payload = {
        external_id: '',
        email: data.email,
        phone_number: data.phone,
      };

      if (action === 'shopify' && data.customerId) {
        payload.external_id = data.customerId;
      }

      if (!payload.external_id && !payload.email && !payload.phone_number) {
        this.log('RockerBox identify event will not fire. No information provided.');
        return false;
      }
      /* eslint-enable camelcase */

      window.RB.track('identify', payload);
      this.log('Identify event fired', payload);
    }

    return true;
  }

  purchase(order, items, {addon} = {}) {
    if (!super.purchase(order, items, {addon})) {
      return false;
    }

    if (!order || !items) {
      this.log('RockerBox purchase event will not fire when no order/items information provided.');
      return false;
    }

    /* eslint-disable camelcase */

    // send billing address (https://help.rockerbox.com/docs/ingesting-address-data)
    const {billingAddress} = order;
    const address = {
      rb_address_1: billingAddress?.address1,
      rb_address_2: billingAddress?.address2,
      rb_city: billingAddress?.city,
      rb_state: billingAddress?.province,
      rb_zip_code: billingAddress?.zip,
      rb_country: billingAddress?.country,
    };

    const hasAddress = Object.values(address).find(val => (typeof val !== 'undefined'));

    const payload = {
      external_id: order.shopifyCustomerId || '',
      order_id: order.id,
      revenue: addon ? order.subtotal : (order.subtotal + order.shipping).toFixed(2),
      products: JSON.stringify(items),
      address: (typeof hasAddress !== 'undefined') ? CryptoJS.SHA256(JSON.stringify(address)).toString() : '',
      email: order.email,
    };

    /* eslint-enable camelcase */

    window.RB.track('conv.purchase', payload);
    this.log('Purchase event fired', payload);
    return true;
  }

  view() {
    if (!super.view()) {
      return false;
    }

    // https://help.rockerbox.com/docs/gtm_all_pages
    window.RB.track('view');
    this.log('View event fired');
    return true;
  }
}
